import { render } from "./RadarInput.vue?vue&type=template&id=3f1d1a56&scoped=true"
import script from "./RadarInput.vue?vue&type=script&lang=js"
export * from "./RadarInput.vue?vue&type=script&lang=js"

import "./RadarInput.vue?vue&type=style&index=0&id=3f1d1a56&scoped=true&lang=css"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f1d1a56"]])

export default __exports__